import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { useNavigate } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/reset.css";
//import "leaflet/dist/leaflet.css";
import "index.css";
import "assets/semmapp-brand.css";
import { initI18n } from "lang";
import "lang/chartLocale";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
initI18n(false); // Initialize before rendering
root.render(
  //<React.StrictMode>
    <App/>
  //</React.StrictMode>

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
